import { render, staticRenderFns } from "./AppSidebarContainer.vue?vue&type=template&id=732865cf&"
import script from "./AppSidebarContainer.vue?vue&type=script&lang=js&"
export * from "./AppSidebarContainer.vue?vue&type=script&lang=js&"
import style0 from "./AppSidebarContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports